import { useState, useCallback } from "react";
import { useRouter } from "next/navigation";

export function useThunk(thunk) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const router = useRouter();

  const runThunk = useCallback(
    async (arg) => {
      setIsLoading(true);
      setError(null);
      try {
        if (thunk && thunk.__isReduxThunk) {
          throw new Error(
            "Redux thunk detected but `react-redux` is not available. Install `react-redux` or pass a plain async function."
          );
        }

        if (typeof thunk === "function") {
          const response = await thunk(arg);
          return { success: true, response };
        }

        throw new Error("Invalid thunk provided to useThunk");
      } catch (err) {
        console.log(err);

        const errorCode =
          err?.code || err?.payload?.status || err?.status || 500;
        const errorMessage =
          err?.message || err?.payload?.message || "Internal Server Error";
        const customCode = err?.name || err?.payload?.error || "Axios Error";

        const validatedError = {
          code: errorCode,
          message: errorMessage,
          customCode: customCode,
        };

        setError(validatedError);

        if (String(errorCode) === "500") {
          try {
            router.push("/server-error");
          } catch (e) {
          }
          return { success: false, error: validatedError };
        }

        return { success: false, error: validatedError };
      } finally {
        setIsLoading(false);
      }
    },
    [thunk, router]
  );

  return [runThunk, isLoading, error];
}
